import { createContext } from "react";

const DataLoadingContext = createContext(null);

export default DataLoadingContext;
